import { useAnimate } from "react-simple-animate";
import SidebarLinks from "./SidebarLinks";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import HeaderLink from "./HeaderLink";
import '../common/styles/adminDashboard.css'
// import Dashboard from "../components/Dashboard";
import { Route, Routes } from "react-router-dom";
import { NavigationRoutes } from "../../constant/Routes";
import UserLisitingTable from "./user-component/UserLisitingTable";
import DealerListingTable from "./dealer-portal/DealerLisitingTable";
import AdminListingTable from "../../features/admin/Admin";

import PlansListingTable from "../../features/plans/PlansListingTable";
import TiersListingTable from "../../features/tiers/TiersListingTable";

import DashboardApp from "../../features/dashboard/dashboard";

import DashboardDealer from "../../features/dashboard-dealer/dashboard-dealer";

import AboutUs from "../../features/about_us/about_us";

import UserDetail from "./user-component/UserDetails";
import CategoriesListing from "./../../features/category/categories";
import AttributesListing from "./../../features/category/attributes";
import VehiclesListingTable from "../../features/vehicles/VehiclesListingTable";
import GdprEditor from "../../features/gdpr/GDPR";
import PrivacyPolicyEditor from "../../features/privacy-policy/PrivacyPolicy";
import TermsAndConditions from "../../features/terms-and-condition/TermsAndCondition";
import PaymentOption from "../../features/payment-option/PaymentOption";

import SuspisiousListingTable from "../../features/suspisious-activity/SuspisiousListingTable";
import FinanceTable from "../../features/finance/FiananceTable";

import ContactUsListingTable from "../../features/contact-us/ContactUsListingTable";
import AdReportListingTable from "../../features/ad-reports/AdReportListingTable";


import MakeListing from "../../features/make/make";
import AddBlog from "../../features/blog/AddBlog";

import BlogListingTable from "../../features/blog/Blogs";
import ArticleListingTable from "../../features/artical/Article";

import SettingsListingTable from "../../features/settings/SettingsListingTable";

import FaqsListingTable from "../../features/faqs/FaqsListingTable";
import BankListingTable from "../../features/bank/BanksListingTable";
import SoldAdsListingTable from "../../features/sold-ads/SoldAdsListingTable";
import RemovedExpiredAdsListingTable from "../../features/removed-expired-ad/RemovedExpiredAdsListingTable";

import { LocalStorageKeys } from "../../constant/LocalStorageKeys";
import localStorageServices from "../../services/LocalStorage";
import { access } from "../../constant/Constants";
import CarReview from "../../features/car_review/car_review";
import DataRequestListingTable from "../../features/data-request/DataRequestListingTable";
import AddArticle from "../../features/artical/AddArticle";

function AdminDashboard() {

    const { play, style, isPlaying } = useAnimate({
        start: {
            width: "301px",
            minWidth: "300px",
        },
        end: {
            width: "95px",
            minWidth: "95px",
        },
    });


    const userInfo = localStorageServices.getItem(LocalStorageKeys.userInfo);

    const type = userInfo?.type ?? "";
    const access1 = userInfo?.access || "";
    const accessGot = access1.split(",");


    // console.log("keys--------------",localStorageServices.getItem(LocalStorageKeys.userInfo));


    const haveAccess = (featureName) => {
        if (type === "0") {
            return true;
        }
        else if (type === "1" && accessGot.includes(featureName)) {
            return true;
        }
        else {
            return false;
        }
    }



    return (<div className="main_container_dashboard">

        <div className="side_bar_content" style={style}>
            <Sidebar play={play} isPlaying={isPlaying} Options={SidebarLinks} />
        </div>
        <div className="header_table" style={{ width: style.width === "95px" ? "calc(100% - 95px)" : "calc(100% - 300px)" }}>





            <div className="header_dashboard">
                <Navbar Options={HeaderLink} />
            </div>
            <div className="table_dashboard">
                <Routes>
                    {haveAccess(access.dashboard) && <Route path="" element={<DashboardApp />} />}

                    {haveAccess(access.user) && <Route path={NavigationRoutes.VERIFIED_USER_LISTING} element={<UserLisitingTable />} />}
                    {haveAccess(access.user) && <Route path={NavigationRoutes.DEALER_LISTING} element={<DealerListingTable />} />}



                    {haveAccess(access.admin) && <Route path={NavigationRoutes.ACTIVE_ADMIN} element={<AdminListingTable />} />}
                    {haveAccess(access.categories) && <Route path={NavigationRoutes.CATEGORIES} element={<CategoriesListing />} />}
                    {haveAccess(access.categories) && <Route path={NavigationRoutes.SUB_CATEGORIES} element={<CategoriesListing />} />}
                    {haveAccess(access.categories) && <Route path={NavigationRoutes.ATTRIBUTES} element={<AttributesListing />} />}
                    {haveAccess(access.bank) && <Route path={NavigationRoutes.BANKS} element={<BankListingTable />} />}
                    {haveAccess(access.soldAds) && <Route path={NavigationRoutes.SOLD_ADS} element={<SoldAdsListingTable />} />}
                    {haveAccess(access.removedExpiredAds) && <Route path={NavigationRoutes.REMOVED_EXPIRED_ADS} element={<RemovedExpiredAdsListingTable />} />}

                    {haveAccess(access.plan) && <Route path={NavigationRoutes.PLANS} element={<PlansListingTable />} />}

                    {haveAccess(access.tier) && <Route path={NavigationRoutes.TIERS} element={<TiersListingTable />} />}

                    {haveAccess(access.vehicle) && <Route path={NavigationRoutes.VEHICLE} element={<VehiclesListingTable />} />}
                    {haveAccess(access.suspicious) && <Route path={NavigationRoutes.SUSPISIOUS} element={<SuspisiousListingTable />} />}
                    {haveAccess(access.finance) && <Route path={NavigationRoutes.FINANCE} element={<FinanceTable />} />}
                    {/* <Route path={NavigationRoutes.DASHBOARD} element={<DashboardApp />} /> */}
                    {haveAccess(access.about) && <Route path={NavigationRoutes.ABOUT_US} element={<AboutUs />} />}
                    {haveAccess(access.about) && <Route path={NavigationRoutes.CAR_REVIEW} element={<CarReview />} />}

                    {haveAccess(access.makeModel) && <Route path={NavigationRoutes.VEHICLE_MAKE} element={<MakeListing />} />}
                    {haveAccess(access.makeModel) && <Route path={NavigationRoutes.VEHICLE_MODEL} element={<MakeListing />} />}

                    {haveAccess(access.settings) && <Route path={NavigationRoutes.HEADERSETTINGS} element={<SettingsListingTable />} />}
                    {haveAccess(access.settings) && <Route path={NavigationRoutes.GDPR} element={<GdprEditor />} />}
                    {haveAccess(access.settings) && <Route path={NavigationRoutes.PRIVACY_POLICY} element={<PrivacyPolicyEditor />} />}
                    {haveAccess(access.settings) && <Route path={NavigationRoutes.TERMS_AND_CONDIIONS} element={<TermsAndConditions />} />}
                    {haveAccess(access.settings) && <Route path={NavigationRoutes.PAYMENT_OPTION} element={<PaymentOption />} />}

                    {haveAccess(access.blog) && <Route path={NavigationRoutes.ADD_BLOG} element={<AddBlog />} />}
                    {haveAccess(access.blog) && <Route path={NavigationRoutes.EDIT_BLOG} element={<AddBlog />} />}
                    {haveAccess(access.blog) && <Route path={NavigationRoutes.BLOG} element={<BlogListingTable />} />}

                    {haveAccess(access.article) && <Route path={NavigationRoutes.ARTICLE} element={<ArticleListingTable />} />}
                    {haveAccess(access.article) && <Route path={NavigationRoutes.ADD_ARTICLE} element={<AddArticle />} />}
                    {haveAccess(access.article) && <Route path={NavigationRoutes.EDIT_ARTICLE} element={<AddArticle />} />}

                    {/*--- */} {haveAccess(access.settings) && <Route path={NavigationRoutes.FAQS} element={<FaqsListingTable />} />}
                    {haveAccess(access.contact) && <Route path={NavigationRoutes.CONTACTUS} element={<ContactUsListingTable />} />}
                    {haveAccess(access.dataRequest) && <Route path={NavigationRoutes.DATA_REQUEST} element={<DataRequestListingTable />} />}

                    {haveAccess(access.adReport) && <Route path={NavigationRoutes.ADREPORTS} element={<AdReportListingTable />} />}

                    {haveAccess(access.user) && <Route path={NavigationRoutes.USER_DETAILS} element={<UserDetail />} />}

                    {haveAccess(access.dashboardDealer) && <Route path={NavigationRoutes.DEALER_DASHBOARD} element={<DashboardDealer />} />}



                    <Route path="*" element={haveAccess(access.dashboard) ? <DashboardApp /> : <div>You don't have access</div>} />
                </Routes>
            </div>
        </div>
    </div>);
}

export default AdminDashboard;